import { z } from "zod";
import { zReportGroupBy } from "./report.common";
export const zCorpReportRowDom = z.object({
    key: z.string(),
    label: z.string(),
    orders: z.number(),
    kwh: z.number(),
    amount: z.number(),
});
const zCorpReportTotalsDom = z.object({
    orders: z.number(),
    kwh: z.number(),
    amount: z.number(),
});
export const zCorpReportDom = z.object({
    companyId: z.string(),
    dateFrom: z.string(),
    dateTo: z.string(),
    groupBy: zReportGroupBy,
    totals: zCorpReportTotalsDom,
    rows: z.array(zCorpReportRowDom),
});
export const zCorpOrderVehicleDom = z.object({
    brand: z.string().nullable(),
    model: z.string().nullable(),
    stateNumber: z.string().nullable(),
});
export const zCorpOrderDom = z.object({
    orderId: z.string(),
    companyId: z.string(),
    linkId: z.string().nullable(),
    orderNumber: z.string(),
    status: z.string(),
    employeeLabel: z.string().nullable(),
    clientName: z.string().nullable(),
    phoneE164: z.string().nullable(),
    scheduledDate: z.string().nullable(),
    scheduledDateEnd: z.string().nullable(),
    address: z.string().nullable(),
    vehicle: zCorpOrderVehicleDom.nullable(),
    planTotalKwh: z.number().nullable(),
    planCost: z.number().nullable(),
    actualTotalKwh: z.number().nullable(),
    actualCost: z.number().nullable(),
    pricePerKwhSnapshot: z.number().nullable(),
    serviceFeeSnapshot: z.number().nullable(),
    technicianName: z.string().nullable(),
    eta: z.string().nullable(),
    createdAt: z.string(),
    chargedAt: z.string().nullable(),
    isCharged: z.boolean(),
    invoiceId: z.string().nullable(),
    invoiceNumber: z.string().nullable(),
    clientId: z.string().nullable(),
    technicianId: z.string().nullable(),
    routeId: z.string().nullable(),
});
